var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',[_c('v-container',[_c('h1',[_vm._v("Maintenance")]),_c('div',[_vm._v(_vm._s(_vm.maintenanceMessage))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }